"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseActivityIdJsonArray = parseActivityIdJsonArray;
exports.serializeActivityIdJsonArray = serializeActivityIdJsonArray;
exports.readActivitySetsFromVariableValues = readActivitySetsFromVariableValues;
exports.parseActivityResumeScenes = parseActivityResumeScenes;
exports.serializeActivityResumeScenes = serializeActivityResumeScenes;
exports.readActivityResumeScenesFromVariableValues = readActivityResumeScenesFromVariableValues;
const constants_1 = require("./constants");
function parseActivityIdJsonArray(raw) {
    if (raw === undefined || raw === null) {
        return [];
    }
    const s = typeof raw === 'string' ? raw : String(raw);
    if (!s.trim() || s.trim() === '[]') {
        return [];
    }
    try {
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed)) {
            return parsed
                .filter((x) => typeof x === 'string')
                .map(x => x.trim())
                .filter(Boolean);
        }
        // Defensive fallback: handle double-encoded JSON arrays.
        if (typeof parsed === 'string') {
            const parsedAgain = JSON.parse(parsed);
            if (Array.isArray(parsedAgain)) {
                return parsedAgain
                    .filter((x) => typeof x === 'string')
                    .map(x => x.trim())
                    .filter(Boolean);
            }
        }
        return [];
    }
    catch {
        return [];
    }
}
function serializeActivityIdJsonArray(ids) {
    return JSON.stringify([...new Set(ids)]);
}
/**
 * Read in-progress and completed activity ids for the current character from variable values.
 * Ids that no longer exist in the adventure are not stripped here; authors may remove activities
 * while saved JSON still lists old ids — those entries are ignored at display/playable evaluation time.
 */
function readActivitySetsFromVariableValues(getVariable) {
    const inProgress = new Set(parseActivityIdJsonArray(getVariable(constants_1.CHARACTER_ACTIVITIES_IN_PROGRESS_VAR)));
    const completed = new Set(parseActivityIdJsonArray(getVariable(constants_1.CHARACTER_ACTIVITIES_COMPLETED_VAR)));
    return { inProgress, completed };
}
/**
 * Parses JSON object string: activity id → resume scene id for activity-list navigation.
 */
function parseActivityResumeScenes(raw) {
    const out = new Map();
    if (raw === undefined || raw === null) {
        return out;
    }
    const s = typeof raw === 'string' ? raw : String(raw);
    const t = s.trim();
    if (!t || t === '{}') {
        return out;
    }
    try {
        const parsed = JSON.parse(t);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            return out;
        }
        for (const [k, v] of Object.entries(parsed)) {
            const id = String(k).trim();
            const sceneId = typeof v === 'string' ? v.trim() : String(v ?? '').trim();
            if (id && sceneId) {
                out.set(id, sceneId);
            }
        }
    }
    catch {
        return out;
    }
    return out;
}
function serializeActivityResumeScenes(map) {
    const obj = {};
    for (const [k, v] of map) {
        const id = String(k).trim();
        const sid = String(v).trim();
        if (id && sid) {
            obj[id] = sid;
        }
    }
    return JSON.stringify(obj);
}
function readActivityResumeScenesFromVariableValues(getVariable) {
    return parseActivityResumeScenes(getVariable(constants_1.CHARACTER_ACTIVITY_RESUME_SCENES_VAR));
}
//# sourceMappingURL=characterActivityState.js.map